import { IconButton } from "@mui/material";
import SouthIcon from "@mui/icons-material/South";
import NorthIcon from "@mui/icons-material/North";
import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { IDashboardComponent } from "../types";
import { ReactElement } from "react";

interface IProps {
  component: IDashboardComponent<any>;
  updateComponent: (component: IDashboardComponent<any>) => void;
}

const EditComponentTool = ({ component, updateComponent }: IProps ): ReactElement => {

  const onMoveHorizontal = (forward: boolean) => {
    if (forward) {
      updateComponent( { ...component, column: component.column + 1 });
    } else {
      updateComponent( { ...component, column: component.column - 1 });
    }
  };

  const onMoveVertical = (forward: boolean) => {
    if (forward) {
      updateComponent( { ...component, row: component.row + 1 });
    } else {
      updateComponent( { ...component, row: component.row - 1 });
    }
  };


  const onSizeHorizontal = (add: boolean) => {
    if (add) {
      updateComponent( { ...component, columnSpan: component.columnSpan + 1 });
    } else {
      updateComponent( { ...component, columnSpan: component.columnSpan - 1 });
    }
  };

  const onSizeVertical = (add: boolean) => {
    if (add) {
      updateComponent( { ...component, rowSpan: component.rowSpan + 1 });
    } else {
      updateComponent( { ...component, rowSpan: component.rowSpan - 1 });
    }
  };


  return (
    <div className="display-grid "
      style={{ position: "absolute",
        right: 0,
        bottom: 0,
        padding: 4,
        gridTemplateColumns: "auto auto auto auto",
        gridTemplateRows: "auto auto auto auto",
        borderRadius: 4,
        background: "rgba(0, 0, 0, .5)"
      }}>

      <IconButton color="primary" size="small" style={{ gridColumn: 2, gridRow: 1 }}
        onClick={() => onMoveVertical(false)}  disabled={component.row === 1}>
        <NorthIcon style={{ fontSize: 11 }}/>
      </IconButton>
      <IconButton color="primary" size="small" style={{ gridColumn: 1, gridRow: 2 }}
        onClick={() => onMoveHorizontal(false)}  disabled={component.column === 1}>
        <WestIcon style={{ fontSize: 11 }}/>
      </IconButton>
      <IconButton color="primary" size="small" style={{ gridColumn: 3, gridRow: 2 }}
        onClick={() => onMoveHorizontal(true)} disabled={component.column + component.columnSpan > 12}>
        <EastIcon style={{ fontSize: 11 }}/>
      </IconButton>
      <IconButton color="primary" style={{ gridColumn: 2, gridRow: 3 }}
        onClick={() => onMoveVertical(true)} disabled={component.row + component.rowSpan > 12}>
        <SouthIcon style={{ fontSize: 11 }}/>
      </IconButton>


      <IconButton color="primary" size="small" style={{ gridColumn: 5, gridRow: 3 }}
        onClick={() => onSizeHorizontal(true)} disabled={component.column + component.columnSpan > 12}>
        <AddIcon style={{ fontSize: 11 }}/>
      </IconButton>
      <IconButton color="primary" size="small" style={{ gridColumn: 5, gridRow: 1 }}
        onClick={() => onSizeHorizontal(false)} disabled={component.columnSpan === 1}>
        <RemoveIcon style={{ fontSize: 11 }}/>
      </IconButton>

      <IconButton color="primary" size="small" style={{ gridColumn: 3, gridRow: 5 }}
        onClick={() => onSizeVertical(true)} disabled={component.row + component.rowSpan > 12}>
        <AddIcon style={{ fontSize: 11 }}/>
      </IconButton>
      <IconButton color="primary" size="small" style={{ gridColumn: 1, gridRow: 5 }}
        onClick={() => onSizeVertical(false)} disabled={component.rowSpan === 1}>
        <RemoveIcon style={{ fontSize: 11 }}/>
      </IconButton>


    </div>
  );
};

export default EditComponentTool;
